<div class="bg-primary text-center">
    <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">
        {{ 'CreateClient' | translate}}
    </h2>
</div>
<mat-dialog-content class="mat-mdc-dialog-content text-center">
    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
        <mat-card-content class="mat-mdc-card-content text-center">
            <form [formGroup]="form">
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="w-100 m-b-10 txt">
                            <mat-label>{{ 'Name' | translate }} </mat-label>
                            <input matInput placeholder="{{ 'Name' | translate }} " formControlName="name"
                                maxlength="100" />
                            <mat-icon matPrefix class="op-5">
                                <i-tabler name="user" class="icon-20 d-flex"></i-tabler>
                            </mat-icon>

                            @if(f['name'].touched && f['name'].invalid)
                            {
                            <mat-hint class="m-b-16 error-msg">
                                @if(f['name'].errors && f['name'].errors['required'])
                                {
                                <div class="text-error"> {{ 'EnterName' | translate }}</div>
                                }
                            </mat-hint>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="w-100 m-b-10 txt">
                            <mat-label>{{ 'Phone' | translate }}</mat-label>
                            <input matInput placeholder="{{ 'Phone' | translate }}" formControlName="clientPhone"
                                maxlength="11" />
                            <mat-icon matPrefix class="op-5">
                                <i-tabler name="phone" class="icon-20 d-flex"></i-tabler>
                            </mat-icon>
                            @if(f['clientPhone'].touched && f['clientPhone'].invalid)
                            {
                            <mat-hint class="m-b-16 error-msg">
                                @if(f['clientPhone'].errors && f['clientPhone'].errors['required'])
                                {
                                <div class="text-error"> {{ 'EnterPhone' | translate }}</div>
                                }

                                @if(f['clientPhone'].errors && f['clientPhone'].errors['minlength'])
                                {
                                <div class="text-error"> {{ 'LengthPhone' | translate }}</div>
                                }

                                @if(f['clientPhone'].errors && f['clientPhone'].errors['pattern'])
                                {
                                <div class="text-error"> {{ 'digitsError' | translate }}</div>
                                }
                            </mat-hint>
                            }
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </mat-card-content></mat-card>
    <mat-divider></mat-divider>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="col-md-12  text-center">
        <button mat-button class="orangSavebtn" (click)="submit()"> {{ 'Save' | translate}}</button>
        <button mat-button class="btnClose" (click)="onClose()"> {{ 'Cancel' | translate}}</button>
    </div>
</mat-dialog-actions>